import biboClient from './biboClient';

const axiosInstance = biboClient.create();

export default {
  getRoles: () => {
    return axiosInstance.get('api/users/roles');
  },
  getBrands: () => {
    return axiosInstance.get('api/users/brands');
  },
  getBrandsMarkets: () => {
    return axiosInstance.get('api/users/brands-markets');
  },

  getList: () => {
    return axiosInstance.get('api/users');
  },
  get: id => {
    return axiosInstance.get(`api/users/${id}`);
  },
  post: data => {
    return axiosInstance.post('api/users', data);
  },
  put: (id, data) => {
    return axiosInstance.put(`api/users/${id}`, data);
  },
  delete: id => {
    return axiosInstance.delete(`api/users/${id}`);
  },

  getUserManagementRemark: () => {
    return axiosInstance.get('api/usermanagementremark');
  },
  postUserManagementRemark: data => {
    return axiosInstance.post('api/usermanagementremark', data);
  },
};
